var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#szolgaltatasok"}},[_c('button',{staticClass:"button",attrs:{"type":"button"}},[_vm._v("Bővebben")])])
}]

export { render, staticRenderFns }